import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

/**
 * Applies the user's chosen aesthetic preset by setting `data-theme` on <html>.
 * Falls back to sakura_pastel for anonymous users / onboarding.
 */
export default function ThemeApplier({ children }) {
  const { user } = useAuth();

  useEffect(() => {
    const preset =
      (user && typeof user === "object" && user.aesthetic_preset) || "sakura_pastel";
    document.documentElement.setAttribute("data-theme", preset);
  }, [user]);

  return <>{children}</>;
}
